
var moment = require("moment");

function getLastSunday(year, month) {
    let d = moment.utc([year, month - 1, 1, 1, 0, 0, 0]).endOf('month');
    const sunday = d.date() - d.day();
    return moment.utc([year, month - 1, sunday, 1, 0, 0, 0]);
}

export const getDKTimeZone = (utcTimestamp) => {
    const year = moment(utcTimestamp).year();
    const lastSunOf3 = moment(getLastSunday(year, 3));
    const lastSunOf10 = moment(getLastSunday(year, 10));
    return (lastSunOf3 <= utcTimestamp && utcTimestamp < lastSunOf10) ? 2 : 1;
}

export const getDKtime = (utcTimestamp) => {
    const utz = new Date().getTimezoneOffset() / -60;
    const timezone = getDKTimeZone(utcTimestamp);

    return (utz !== timezone) ? moment.utc(utcTimestamp).utcOffset(timezone * 60).format('HH:mm') : '';
}

export const getDKtimeText = (utcTimestamp) => {
    const tm = getDKtime(utcTimestamp);
    return (tm !== '') ? ' (' + tm + ' DK)' : '';
}

export const getDKDateTime = (utcTimestamp) => {
    const utz = new Date().getTimezoneOffset() / -60;
    const timezone = getDKTimeZone(utcTimestamp);

    const tTime = moment(+utcTimestamp);
    const tzTime = moment.utc(+utcTimestamp).utcOffset(timezone * 60);

    if (utz !== timezone) {
        if (tTime.date() !== tzTime.date()) {
            return tzTime.format('DD/MM HH:mm');
        } else {
            return tzTime.format('HH:mm');
        }
    }
    return '';
}

export const getDKDateTimeText = (utcTimestamp) => {
    const tm = getDKDateTime(utcTimestamp);
    return (tm !== '') ? ' (' + tm + ' DK)' : '';
}

export const getDKTimeRange = (from, to) => {
    const utz = new Date().getTimezoneOffset() / -60;
    const timezone = getDKTimeZone(from);
    let dt = '';
    if (utz !== timezone) {
        const _from = moment.utc(+from).utcOffset(timezone * 60).format('HH:mm');
        const _to = moment.utc(+to).utcOffset(timezone * 60).format('HH:mm');
        dt = `(${_from} - ${_to} DK) `;
    }

    return dt;
}

export const getDKDateTimeRange = (from, to) => {
    const utz = new Date().getTimezoneOffset() / -60;
    const timezone = getDKTimeZone(from);
    let dt = '';
    let _from = '';
    let _to = '';
    if (utz !== timezone) {
        const tFrom = moment(+from);
        const tzFrom = moment.utc(+from).utcOffset(timezone * 60);
        const tTo = moment(+to);
        const tzTo = moment.utc(+to).utcOffset(timezone * 60);

        if (tFrom.date() !== tzFrom.date() || tTo.date() !== tzTo.date()) {
            _from = tzFrom.format('DD/MM/YYYY HH:mm');
            _to = tzTo.format('DD/MM/YYYY HH:mm');
        } else {
            _from = tzFrom.format('HH:mm');
            _to = tzTo.format('HH:mm');
        }

        dt = `(${_from} - ${_to} DK) `;
    }

    return dt;
}

export const isNotDKTimeZone = () => {
    const utz = new Date().getTimezoneOffset() / -60;
    const timezone = getDKTimeZone(new Date().getTime());
    return utz !== timezone;
}